export const type = 'removeProduct';

const removeProduct = (product) => ({
    type,
    payload: product,
});

export default removeProduct;